import { computed, ComputedRef, onUnmounted, ref } from '@vue/composition-api';

// SP(スマホ)表示に切り替える画面サイズ(表示領域の幅、または端末画面の短辺)の上限。
const SP_MAX_SCREEN_SIZE_PX = 575;
// 縦向きのスマホや、PCでウィンドウ幅を狭めた場合はブラウザの表示領域の幅で判定する
const SP_WIDTH_MEDIA_QUERY = `(max-width: ${SP_MAX_SCREEN_SIZE_PX}px)`;

// 横向きのスマホ: タッチ端末かつ端末画面の短辺が小さい(回転・キーボード表示・ページの縮尺で変化しない)
const isSmallTouchDevice = (): boolean => {
  const isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
  const screenShortSidePx = Math.min(window.screen.width, window.screen.height);
  return isCoarsePointer && screenShortSidePx <= SP_MAX_SCREEN_SIZE_PX;
};

export function useSpScreen(): ComputedRef<boolean> {
  const isSmallTouch = isSmallTouchDevice();
  const widthMediaQueryList = window.matchMedia(SP_WIDTH_MEDIA_QUERY);
  const isNarrowViewport = ref<boolean>(widthMediaQueryList.matches);
  const onChange = (event: { matches: boolean }): void => {
    isNarrowViewport.value = event.matches;
  };
  widthMediaQueryList.addEventListener('change', onChange);
  onUnmounted(() => widthMediaQueryList.removeEventListener('change', onChange));
  return computed<boolean>(() => isSmallTouch || isNarrowViewport.value);
}
